import React, { lazy } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Users, BookOpen, Sparkles } from 'lucide-react';
const testimonials = [{
  photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'María F., Buenos Aires',
  role: '32 años',
  text: 'En 3 días mi panza dejó de estar hinchada todo el tiempo. No lo podía creer. Pensé que era algo que iba a tener que soportar para siempre.'
}, {
  photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'Laura C., Córdoba',
  role: '28 años',
  text: 'El protocolo del nervio vago cambió mi vida. Ahora tengo una herramienta real para cuando siento que colapso. Ya no dependo de pastillas.'
}, {
  photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=96&h=96&fit=crop&crop=faces&fm=webp&q=75',
  name: 'Sofía P., Rosario',
  role: '41 años',
  text: 'Recuperé mi energía sin tomar café todo el día. Me levanto descansada y llego a la noche sin arrastrarme. Es increíble.'
}];
export function SocialProof() {
  return <section className="py-16 bg-brand-card border-y border-brand-border" data-id="element-293">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-294">
        <FadeIn data-id="element-295">
          <div className="text-center mb-12" data-id="element-296">
            <p className="text-brand-accent font-bold tracking-widest uppercase text-sm mb-2" data-id="element-297">
              Testimonios Reales
            </p>
            <h2 className="text-3xl font-bold" data-id="element-298">
              Lo que dicen las mujeres que ya lo tienen
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-299">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className="bg-brand-cream border border-brand-border border-l-[3px] border-l-brand-terracotta p-6 rounded-2xl relative" data-id="element-300">
              <div className="flex items-center gap-1 mb-4" data-id="element-301">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-terracotta text-brand-terracotta" data-id="element-302" />)}
              </div>
              <p className="text-brand-dark mb-6 italic leading-relaxed" data-id="element-303">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-304">
                <img src={t.photo} alt={t.name} loading="lazy" decoding="async" width="48" height="48" className="w-12 h-12 rounded-full object-cover shrink-0 border-2 border-white shadow-sm" data-id="element-305" />
                <div data-id="element-306">
                  <div className="font-bold text-sm" data-id="element-307">{t.name}</div>
                  <div className="text-xs text-brand-muted" data-id="element-308">{t.role}</div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-309">
          <div className="flex flex-wrap justify-center gap-8 md:gap-16 text-center border-t border-brand-border pt-10" data-id="element-310">
            <div data-id="element-311">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-312">
                <Users className="w-6 h-6 text-brand-accent" data-id="element-313" /> +300
              </div>
              <div className="text-sm text-brand-muted" data-id="element-314">mujeres confiaron</div>
            </div>
            <div data-id="element-315">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-316">
                <BookOpen className="w-6 h-6 text-brand-accent" data-id="element-317" /> 3
              </div>
              <div className="text-sm text-brand-muted" data-id="element-318">Tomos completos</div>
            </div>
            <div data-id="element-319">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-320">
                <Sparkles className="w-6 h-6 text-brand-accent" data-id="element-321" /> 72hs
              </div>
              <div className="text-sm text-brand-muted" data-id="element-322">
                Primeros resultados
              </div>
            </div>
            <div data-id="element-323">
              <div className="flex items-center justify-center gap-2 text-3xl font-bold text-brand-dark mb-1" data-id="element-324">
                <Star className="w-6 h-6 text-brand-terracotta fill-brand-terracotta" data-id="element-325" />{' '}
                4.8/5
              </div>
              <div className="text-sm text-brand-muted" data-id="element-326">calificación ⭐</div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}